define('bizzabo/views/FormMixin',[
    'jquery',
    'jquery-chosen',
    'jquery-charcount',
    'jquery-placeholder',
    'underscore',
    'bizzabo/utils',
    'bizzabo/consts'
], function(
    $,
    jQueryChosen,
    jQueryCharCount,
    jQueryPlaceholder,
    _,
    UTILS,
    Consts
    ) {

    var FormMixin = {

        /*
         keyPressValidationFields : [],
         validationFields : [],
         noAutoVFields : [],
         counterDoNotMovesErrorMsg : undefined,
         disableChosen : false
         ignoredAttributes : []
         */
        autoVFields : [],

        initValidation : function(counterDoNotMovesErrorMsg) {
            if (counterDoNotMovesErrorMsg) {
                this.counterDoNotMovesErrorMsg = counterDoNotMovesErrorMsg;
            }

            this.events = this.events || {};

            this.model.on(Consts.Strings.VALIDATION_NAME, this.onAttrValidation, this);
            this.model.on('validated', this.afterValidation, this);
            this.model.on('change', this.onModelChange, this);
            this.model.onChildSyncedCollectionsOrModels('change', this.onModelChange, this);
            this.model.on('sync', this.onModelSync, this);

            if (_.isUndefined(this.validationFields) || this.validationFields.length === 0) {
                this.validationFields = _.keys(this.model.validation);
            }

            var keyPressValidationFields = this.keyPressValidationFields || [];
            for (var i = 0; i < keyPressValidationFields.length; i++) {
                var attr = keyPressValidationFields[i];
                this.events['keyup [name="' + attr + '"]'] = "onKeyPressValidation";
            }

            this.autoVFields = _.difference(this.validationFields, this.noAutoVFields ? this.noAutoVFields : []);
            this.ignoredAttributes = this.ignoredAttributes || [];

            // Init Counters
            this.events['focus input'] = 'showCounter';
            this.events['blur input'] = 'hideCounter';
            this.events['focus textarea'] = 'showCounter';
            this.events['blur textarea'] = 'hideCounter';

            this.model.isBeingEdited = true;
        },

        removeValidation : function() {
            this.model.isBeingEdited = false;
            this.model.wasEdited = true;
            this.model.validate();
            this.model.off(Consts.Strings.VALIDATION_NAME, this.onAttrValidation, this);
            this.model.off('validated', this.afterValidation, this);
            this.model.off('change', this.onModelChange, this);
            this.model.offChildSyncedCollectionsOrModels('change', this.onModelChange, this);
            this.model.off('sync', this.onModelSync, this);
            this.undelegateEvents();
        },

        onModelChange : function(model) {
            var changed = model.changedAttributes() || {};
            var changedAttributes = _.difference(_.keys(changed), this.ignoredAttributes);
            if (changedAttributes.length > 0) {
                this.model.isSynced = false;
                this.model.wasChangedFromForm = true;
            }
        },

        onModelSync : function() {
            this.model.setFlagsAfterSync();
        },

        showCounter : function(e) {
            var attr = e.target.name;
            this.$('.' + attr + 'Counter').hide().fadeIn();
            if (this.counterDoNotMovesErrorMsg) {
                return;
            }
            this.$('.' + attr + 'ErrorMsg').animate({
                right : '30px'
            }, 500);
        },

        hideCounter : function(e) {
            var attr = e.target.name;
            this.$('.' + attr + 'Counter').show().fadeOut();
            if (this.counterDoNotMovesErrorMsg) {
                return;
            }
            this.$('.' + attr + 'ErrorMsg').animate({
                right : '0'
            }, 500);
        },

        renderInputCounters : function() {
            var thisView = this;
            var createCounter = function(inputElement) {
                var attr = inputElement.attr('name');
                if (!attr) {
                    return;
                }

                var counterElement = thisView.$('.' + attr + 'Counter');
                if (counterElement.length <= 0) {
                    return;
                }

                var allowed = -1;
                var validations = UTILS.ensureArray(thisView.model.validation[attr]);
                for (var i = 0; i < validations.length; i++) {
                    allowed = validations[i].maxLength || allowed;
                }

                if (allowed < 0) {
                    return;
                }

                inputElement.charCount({
                    allowed : allowed,
                    warning : 0,
                    el : counterElement
                });
            };

            this.$('input, textarea').each(function(index, value) {
                createCounter($(value));
            });
        },

        renderForm : function() {
            // Apply values to selects and apply the Chosen plugin
            var selects = this.$('select'),
                thisView = this;
            selects.each(function(index, value) {
                var modelValue = thisView.model.get(value.name);
                if (modelValue) {
                    thisView.$(value).val(modelValue);
                }

                if (!thisView.disableChosen) {
                    $(value).chosen({width : $(value).outerWidth() + 'px'});
                }
            });

            this.renderInputCounters();

            // Add support for placeholders in non-HTML5 browsers
            this.$('input[placeholder], textarea[placeholder]').placeholder();

            if (this.shouldValidate()) {
                this.model.validate();
            }
        },

        shouldValidate: function() {
            return (this.model.wasEdited || this.model.isSynced);
        },

        afterValidation : function() {
            var thisView = this,
                currentAttrs = _.keys(this.model.attributes),
                attrs = _.intersection(this.autoVFields, currentAttrs);
            _.each(attrs, function(attr) {
                var showOk = (thisView.model.has(attr) && thisView.model.isValid(attr) && thisView.model.get(attr).length > 0),
                    element = thisView.$('[name="' + attr + '"]');
                element.toggleClass('fieldOk', showOk);
            });
        },

        onAttrValidation : function(options) {
            this.setErrorIndicator(this, options.attr, options.error);
        },

        setErrorIndicator : function(view, attr, error, drawOk) {
            if (_.indexOf(view.validationFields, attr) === -1) {
                return;
            }
            view.setFieldErrorIndicator(view, attr, error, drawOk);
        },

        setFieldErrorIndicator : function(view, attr, error, drawOk) {
            var isValid = _.isUndefined(error) || error.length === 0,
                element = view.$('[name="' + attr + '"]'),
                errorMsgElement = view.$('.' + attr + 'ErrorMsg');
            view.markFieldValidation(element, isValid, drawOk);
            view.animateErrorMsg(errorMsgElement, error);
        },

        markFieldValidation : function(element, isValid, drawOk) {
            if (drawOk) {
                element.toggleClass('fieldOk', isValid);
            }
            element.toggleClass('fieldError', !isValid);
        },

        animateErrorMsg : function(errorMsgElement, errorMsg) {
            var isValid = (_.isUndefined(errorMsg) || errorMsg.length === 0);
            var errorMessageChanged = (errorMsgElement.text() !== errorMsg);
            if (isValid && (errorMsgElement.text().length > 0)) {
                errorMsgElement.stop(true, true).hide("slide", {
                    direction : "right"
                }, 500, function() {
                    errorMsgElement.text('');
                });
            } else if (!isValid && errorMessageChanged) {
                errorMsgElement.stop(true, true).text(errorMsg).show("slide", {
                    direction : "right"
                }, 500);
            }
        },

        onKeyPressValidation : function(eventObject) {
            var ev = eventObject || event;
            var tabKey = 9;
            if (ev.keyCode === tabKey) {
                return;
            }
            var attr = ev.currentTarget.name;
            this.keyPressValidation(attr);
        },

        keyPressValidation : function(attr, validations) {
            if (_.isUndefined(validations)) {
                validations = this.model.validation[attr];
            }
            validations = UTILS.ensureArray(validations);

            var newVal = this.$('[name="' + attr + '"]').val();
            var error;

            for (var i = 0; i < validations.length; i++) {
                var validation = validations[i];
                if (validation.required) {
                    error = newVal.length === 0 ? validation.msg : error;
                }
                if (validation.maxLength) {
                    error = newVal.length > validation.maxLength ? validation.msg : error;
                }
            }
            this.setErrorIndicator(this, attr, error, true);
            this.model.trigger(Consts.Notifications.validation.KEY_PRESS_VALIDATION + ":" + (error ? "invalid" : "valid"), attr);
        }
    };


   return FormMixin;

});

